import { useQuery } from "react-query";
import axios from "axios";
import { useRef, useState } from "react";
import "./examcomplete.scss";
import Loader from "../components/loader";
import LoadError from "../components/error";
import { ApiEndpoint, formatResultsData } from "../components/utils";
import { pageIds } from "../components/utils";
import { BrandButton } from "../components/form/buttons";
import { useNavigate } from "react-router-dom";
import NetworkError from "../components/networkError";
import { ExamResultsToHTML } from "../components/data2html";
import { renderToString } from "react-dom/server";
import { getAppInfo, getUserInfo } from "../components/user";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

interface PageResponse {
  headerTitle?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  welcomeMessage?: any;
}

const ExamComplete = () => {
  dayjs.extend(utc);
  const navigate = useNavigate();
  const emailSent = useRef(false);
  const snapshotCreated = useRef(false);
  const [data, setdata] = useState<PageResponse | null>();
  const [hasError, setHasError] = useState(false);
  const userData = getUserInfo();
  const examData = getAppInfo()?.currentExamData;

  const { isLoading, error } = useQuery("examResultsPageData", async () => {
    const resp = await axios.get(
      ApiEndpoint +
        "wp-json/satapp-api/v1/getPageText?slug=" +
        pageIds.exam_complete
    );
    setdata(resp.data as PageResponse);

    const resp2 = await axios.post(
      ApiEndpoint + "wp-json/satapp-api/v1/testResults",
      {
        token: userData?.token,
        exam_id: examData?.examId,
      }
    );
    if (!resp2) {
      setHasError(true);
      return;
    } else {
      if (snapshotCreated.current) return;
      const stats = formatResultsData(
        resp2.data,
        examData?.verbalScoringMatrix,
        examData?.mathScoringMatrix,
        examData?.verbalMinScore,
        examData?.mathMinScore
      );

      //add username, test name and date to stats
      const currentExam = getAppInfo()?.examData?.filter(
        (items) => items.examId == getAppInfo()?.currentExamData?.examId
      )[0];
      stats.testName = currentExam ? currentExam?.examName : "";
      stats.userName = `${userData?.first_name} ${userData?.last_name}`;
      stats.testDate = dayjs
        .utc(resp2.data[0].snapshotDatetime)
        .local()
        .format("MM/DD/YYYY h:ma");

      const html = renderToString(ExamResultsToHTML(stats));
      createSnapshot();
      snapshotCreated.current = true;
      sendExamEndEmail(html);
    }
  });

  const createSnapshot = async () => {
    const userData = getUserInfo();
    await axios.post(ApiEndpoint + "wp-json/satapp-api/v1/snapShot", {
      token: userData?.token,
      exam_id: examData?.examId,
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const sendExamEndEmail = async (html: any) => {
    const userData = getUserInfo();
    if (emailSent.current === true) return;
    await axios.post(ApiEndpoint + "wp-json/satapp-api/v1/sendEmail", {
      token: userData?.token,
      output: html,
    });
    emailSent.current = true;
  };

  if (isLoading) return <Loader />;
  if (error) return <LoadError />;

  return (
    <div className="examCompletePage">
      <div className="headline">
        <h1>{data?.headerTitle}</h1>
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: data?.welcomeMessage }}
        />
        <div className="btnHolder">
          <BrandButton
            onClick={() => navigate("/exam-results", { replace: true })}
          >
            VIEW YOUR RESULTS
          </BrandButton>
        </div>
      </div>
      <NetworkError open={hasError} />
    </div>
  );
};

export default ExamComplete;
